import { useTranslation } from 'react-i18next'
import { HeroBackdrop } from '#app/components/hero-backdrop.tsx'
import { type Route } from './+types/imprint.ts'

export const meta: Route.MetaFunction = () => [
	{
		title: 'Impressum | Open Sourced',
	},
	{
		name: 'description',
		content: 'Impressum der Open Sourced GmbH, Lostorf, Switzerland.',
	},
]

export default function ImprintRoute() {
	const { t } = useTranslation()

	return (
		<>
			{/* Hero */}
			<section className="relative overflow-hidden pt-32 pb-24">
				<HeroBackdrop />

				<div className="container relative z-10 text-center">
					<h1 className="mx-auto max-w-3xl text-h3 sm:text-h2 md:text-h1 hyphens-manual break-words">
						{t('legal.imprint.heading')}
					</h1>
				</div>
			</section>

			{/* Company info */}
			<section className="py-24">
				<div className="container max-w-3xl">
					<dl className="space-y-6">
						<div>
							<dt className="text-body-sm font-semibold text-muted-foreground">
								{t('legal.imprint.responsibleLabel')}
							</dt>
							<dd className="mt-1 text-body-md">
								{t('legal.imprint.owner')}
							</dd>
						</div>

						<div>
							<dd className="text-h4">
								{t('legal.imprint.companyName')}
							</dd>
						</div>

						<div>
							<dt className="text-body-sm font-semibold text-muted-foreground">
								{t('legal.imprint.addressLabel')}
							</dt>
							<dd className="mt-1 text-body-md">
								{t('legal.imprint.address')}
								<br />
								{t('legal.imprint.city')}
								<br />
								{t('legal.imprint.country')}
							</dd>
						</div>

						<div>
							<dt className="text-body-sm font-semibold text-muted-foreground">
								{t('legal.imprint.uidLabel')}
							</dt>
							<dd className="mt-1 text-body-md">
								{t('legal.imprint.uid')}
							</dd>
						</div>

						<div>
							<dt className="text-body-sm font-semibold text-muted-foreground">
								{t('legal.imprint.emailLabel')}
							</dt>
							<dd className="mt-1 text-body-md">
								<a
									href={`mailto:${t('legal.imprint.email')}`}
									className="link-inline focus-cosy"
								>
									{t('legal.imprint.email')}
								</a>
							</dd>
						</div>
					</dl>
				</div>
			</section>
		</>
	)
}
